const BASE_ACTION = "SMART_INSIGHTS";
export const FETCH_ANOMALY_SUCCESS = `${BASE_ACTION}/FETCH_ANOMALY_SUCCESS`;
export const RESET_ANOMALY = `${BASE_ACTION}/RESET_ANOMALY`;
export const FETCH_ANOMALY_FAIL = `${BASE_ACTION}/FETCH_ANOMALY_FAIL`;
